import * as R from 'ramda';
import {
  Interval,
} from 'luxon';

export * from './time-util';
export * from './worklogs-util';

export const mergeValues = (
  values,
  state,
) => (
  Object.keys(values).reduce((s, v) => ({
    ...s,
    [v]: values[v]?._merge ? ({ // eslint-disable-line
      ...state[v],
      ...R.dissoc('_merge', values[v]),
    }) : (
      values[v]
    ),
  }), {})
);

export const scrollbarSize = (() => {
  const div1 = window.document.createElement('div');
  const div2 = window.document.createElement('div');

  div1.style.width = '100px';
  div1.style.overflowX = 'scroll';
  div2.style.width = '100px';

  if (!window.document.body) {
    return 0;
  }

  window.document.body.appendChild(div1);
  window.document.body.appendChild(div2);

  const size = div1.offsetHeight - div2.offsetHeight;

  window.document.body.removeChild(div1);
  window.document.body.removeChild(div2);

  return size;
})();

export const capitalizeFirstLetter = string => (
  `${string.charAt(0).toUpperCase()}${string.slice(1)}`
);

let lastSelected = null;

export const calculateCalendarSelection = (currentSelection, newDate, event) => {
  const isShiftDown = event.nativeEvent.shiftKey;

  if (isShiftDown && lastSelected) {
    const lastDateAndNewDateDiff = lastSelected.diff(newDate);
    const [firstDay, lastDay] = lastDateAndNewDateDiff > 0
      ? [newDate, lastSelected]
      : [lastSelected, newDate];

    const newSelectionInterval = Interval.fromDateTimes(
      firstDay,
      lastDay,
    );

    const newSelectionIntervalLength = newSelectionInterval.count('days');

    const newSelectionArray = Array(newSelectionIntervalLength)
      .fill(0)
      .map((_, days) => newSelectionInterval.start.plus({ days }));

    const resultingInterval = R.without(
      R.intersection(
        newSelectionArray,
        currentSelection,
      ),
      R.union(
        currentSelection,
        newSelectionArray,
      ),
    );

    return R.contains(
      lastSelected,
      currentSelection,
    )
      ? [
        ...resultingInterval,
        lastSelected,
      ]
      : R.without(
        [lastSelected],
        resultingInterval,
      );
  }

  lastSelected = newDate;

  return R.contains(
    newDate,
    currentSelection,
  )
    ? R.without(
      [newDate],
      currentSelection,
    ) : [
      ...currentSelection,
      newDate,
    ];
};

export const calculateSidebarSelection = (currentSelection, id, groupBy) => {
  const scopedSelection = currentSelection[groupBy];
  const newSelection = R.contains(
    id,
    scopedSelection,
  )
    ? R.without(
      [id],
      scopedSelection,
    ) : [
      ...scopedSelection,
      id,
    ];

  return {
    ...currentSelection,
    [groupBy]: newSelection,
  };
};

export const validateJiraTime = value => /^(?:\d{1,2}d{1}(?:\s{1}|$))?(?:\d{1,2}h{1}(?:\s{1}|$))?(?:\d{1,2}m{1}(?:\s{1}|$))?(?:\d{1,2}s{1}(?:\s{1}|$))?$/.test(value);
